import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConvertDownloadCSVService {

  constructor() { }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    if(objArray.length == undefined)
    {
      str = ''
    }
    else
    {
      str = 'S.No,'
    }
    // let row = 'S.No,';
    let row = '';
    for (let index in headerList) {
     row += headerList[index] + ',';
    }    
    row = row.slice(0, -1);
    // console.log(array.length, array);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
     let line = (i+1)+'';
     for (let index in headerList) {
      let head = headerList[index];
      line += ',' + array[i][head];
     }
     str += line + '\r\n';
    }
    return str;
   }

  downloadFile(data, filename='data',heading)
  {
    // console.log("called data is",data,"fileName is",filename,"heading is",heading);
    let csvData = this.ConvertToCSV(data, heading);
    // console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "show";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
}
